import { useLocation, useNavigate, useParams } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import { Box, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import SearchBar from "../../components/SearchBar";
import React from "react";
import OffersPendingList from "../../features/manageOffers/offersPendingList";
import OffersAcceptedList from "../../features/manageOffers/offersAcceptedList";
import OffersRejectedList from "../../features/manageOffers/offersRejectedList";
import OffersApprovedList from "../../features/manageOffers/offersApprovedList";
import OffersScheduledList from "../../features/manageOffers/offersScheduledList";
import OffersInprogressList from "../../features/manageOffers/offersInprogressList";
import OffersCompletedList from "../../features/manageOffers/offersCompletedList";
import {
  useAcceptRejectOfferMutation,
  useGetInvoiceMutation,
  useLazyGetIssueByIdQuery,
  useLazyGetOffersQuery,
} from "../../services/main";
import { showError, showToast, showWarning } from "../../constants/toasts";
import { Issue, Offers } from "../../types/General";
import moment from "moment";
import { isValidInput } from "../../utils/validations";
import { OFFER_STATUS } from "../../utils/enums";
import TeamDocumentModal from "../../Modals/teamDocument";
import { socket } from "../../utils/socket";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const ManageOffers = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { state } = useLocation();
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState<Offers[]>([]);
  const [page, setPage] = useState<number>(1);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [searchTerm, setSearchTerm] = useState("");
  const [rejectionRsn, setRejectionRsn] = useState("");
  const [commission, setCommission] = useState("");
  const [pdfFile, setPdfFile] = useState("");
  const [selectedId, setSelectedId] = useState("");
  const [selectedPrice, setSelectedPrice] = useState("");
  const [selectedQuatation, setSelectedQuatation] = useState("");
  const [error, setError] = useState("");
  const [count, setCount] = useState(0);
  const [valueTabs, setValueTabs] = useState(0);
  const [open, setOpen] = useState(false);
  const [docOpen, setDocOpen] = useState(false);
  const [open1, setOpen1] = useState(false);

  const [issuesDetail, setIssueDetail] = useState<Issue | null>(null);

  const [issueById] = useLazyGetIssueByIdQuery();
  const [invoice] = useGetInvoiceMutation();
  const [getOffersMethod] = useLazyGetOffersQuery();
  const [updateStatus] = useAcceptRejectOfferMutation();

  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };

  const getData = async (id: string) => {
    setLoading(true);
    try {
      const response = await issueById({
        id,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        setIssueDetail(response?.data || null);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  const getOffers = async (id: string) => {
    setLoading(true);
    try {
      const response = await getOffersMethod({
        page,
        limit: 10,
        search: debouncedSearchTerm.trim(),
        issueId: id,
        status: valueTabs + 1,
      }).unwrap();
      setLoading(false);

      if (response?.statusCode === 200) {
        setLoading(false);
        setRows(response?.data?.data || []);
        setCount(response?.data?.count || 0);
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
      setLoading(false);
    }
  };

  const handleInvoice = async ({
    offerId,
    issueId,
  }: {
    offerId: string;
    issueId: string;
  }) => {
    console.log(offerId, issueId, "invoicefunction");

    const body = {
      offerId,
      issueId,
    };

    try {
      const response = await invoice(body).unwrap();
      if (response?.statusCode === 200) {
        if (response?.data) {
          window.open(response?.data, "_blank");
        }
      }
    } catch (error: any) {
    } finally {
    }
  };

  const handleStatusUpdate = async (status: number) => {
    if (selectedId) {
      if (status === OFFER_STATUS.REJECTED && !rejectionRsn) {
        showWarning("Please add rejection reason");
        return;
      }

      if (status === OFFER_STATUS.ACCEPTED && !commission) {
        showWarning("Please add commission");
        return;
      }
      if (status === OFFER_STATUS.ACCEPTED && !pdfFile) {
        showWarning("Please add admin quotation");
        return;
      }
      const body = {
        offerId: selectedId,
        status: status,
        ...(status === OFFER_STATUS.REJECTED
          ? { rejectReason: rejectionRsn || "" }
          : {}),
        ...(status === OFFER_STATUS.ACCEPTED
          ? { adminCommission: Number(commission) || 0 }
          : {}),
        ...(status === OFFER_STATUS.ACCEPTED
          ? { adminQuoatation: pdfFile || "" }
          : {}),
      };

      try {
        const response = await updateStatus(body).unwrap();
        if (response?.statusCode === 200) {
          if (status === OFFER_STATUS.REJECTED) {
            showToast("Offer rejected successfully");
          } else {
            showToast("Offer accepted successfully");
          }
          setValueTabs(status === OFFER_STATUS.REJECTED ? 6 : 1);
          setOpen1(false);
          setOpen(false);
          if (id) {
            getData(id);
          }
        } else {
          showError("Please try again");
        }
      } catch (error: any) {
        console.log(error, "errror");
        showError(error?.data?.message || "");
      }
    }
  };

  useEffect(() => {
    if (id) {
      getData(id);
    }
  }, []);

  useEffect(() => {
    if (state) setValueTabs(Number(state));
  }, [state]);

  useEffect(() => {
    if (id) {
      getOffers(id);
    }
  }, [debouncedSearchTerm, page, valueTabs]);

  useEffect(() => {
    socket.on("statusUpdateOk", (response: any) => {
      console.log(response, "response socket");
      if (response?.status === 200) {
        let status = response?.data?.data?.status;
        console.log(status, "statusstatus");
        if (status === OFFER_STATUS.APPROVED) {
          setValueTabs(2);
        } else if (status === OFFER_STATUS.SCHEDULED) {
          setValueTabs(3);
        } else if (status === OFFER_STATUS.INPROGRESS) {
          setValueTabs(4);
        } else if (status === OFFER_STATUS.COMPLETED) {
          setValueTabs(5);
        } else if (status === OFFER_STATUS.REJECTED) {
          setValueTabs(6);
        }
      }
    });

    return () => {
      socket.off("statusUpdateOk");
    };
  }, []);

  return (
    <MainContainer>
      <div className="main_title">
        <h1>Manage Issues - Offers</h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -{" "}
          <span onClick={() => navigate("/manage-issues")}>Manage Issues</span>{" "}
          - Offers
        </p>
      </div>

      <div className="cards view_page">
        <div className="section_title">
          <h2>Issues Details</h2>
        </div>
        <div className="gap_p">
          <div className="vew_img no_radius w_100">
            <h6>Image</h6>

            <div className="imageDiv">
              {issuesDetail?.image?.length
                ? issuesDetail?.image?.map((item) => (
                    <figure>
                      <img
                        alt="user"
                        src={item || "/static/images/placeholder.png"}
                      />
                    </figure>
                  ))
                : null}
            </div>
          </div>
          <div className="w_33">
            <h6>Issue Name</h6>
            <p>{issuesDetail?.name || "-"}</p>
          </div>
          <div className="w_33">
            <h6>Property</h6>
            <p>{issuesDetail?.propertyId?.name || "-"}</p>
          </div>
          <div className="w_33">
            <h6>Category</h6>
            <p>{issuesDetail?.categoryId?.categoryName || "-"}</p>
          </div>
          <div className="w_33">
            <h6>Date & Time</h6>
            <p>
              {issuesDetail?.createdAt
                ? moment(issuesDetail?.createdAt).format("lll")
                : "-"}
            </p>
          </div>
          <div className="w_33">
            <h6>Work Date</h6>
            <p>
              {issuesDetail?.workDate
                ? moment(issuesDetail?.workDate).format("lll")
                : "-"}
            </p>
          </div>
          <div className="w_33">
            <h6>Address</h6>
            <p>
              {issuesDetail?.address?.city || "-"}
              {issuesDetail?.address?.country || ""}
            </p>
          </div>
          <div className="w_33">
            <h6>City</h6>
            <p>{issuesDetail?.address?.city || "-"}</p>
          </div>
          <div className="w_100">
            <h6>Issue Description</h6>
            <p>{issuesDetail?.description || "-"}</p>
          </div>
        </div>
      </div>

      <div className="cards">
        <div className="section_title">
          <h2>Offers</h2>
        </div>
        <div className="table_header">
          <div className="left_s">
            <Box className="search_box">
              <SearchBar
                placeholder="Search..."
                searchTerm={searchTerm}
                setDebouncedSearchTerm={setDebouncedSearchTerm}
                value={searchTerm}
                onCross={() => setSearchTerm("")}
                onChange={(val: any) => {
                  if (isValidInput(val.target.value)) {
                    setSearchTerm(val.target.value);
                  }
                }}
              />
            </Box>
          </div>
        </div>
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab label="Pending" {...a11yProps(0)} />
            <Tab label="Accepted" {...a11yProps(1)} />
            <Tab label="Approved" {...a11yProps(2)} />
            <Tab label="Scheduled" {...a11yProps(3)} />
            <Tab label="In Progress" {...a11yProps(4)} />
            <Tab label="Completed" {...a11yProps(5)} />
            <Tab label="Rejected" {...a11yProps(6)} />
          </Tabs>
          <CustomTabPanel value={valueTabs} index={0}>
            <OffersPendingList
              count={count}
              rows={rows}
              handlePageChange={handlePageChange}
              setPage={setPage}
              loading={loading}
              page={page}
              handleStatusUpdate={handleStatusUpdate}
              setRejectionRsn={setRejectionRsn}
              rejectionRsn={rejectionRsn}
              setCommission={setCommission}
              setPdfFile={setPdfFile}
              pdfFile={pdfFile}
              commission={commission}
              setSelectedId={setSelectedId}
              selectedPrice={selectedPrice}
              setSelectedPrice={setSelectedPrice}
              setSelectedQuatation={setSelectedQuatation}
              selectedQuatation={selectedQuatation}
              setOpen1={setOpen1}
              setOpen={setOpen}
              open={open}
              open1={open1}
              setDocOpen={setDocOpen}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={1}>
            <OffersAcceptedList
              count={count}
              rows={rows}
              handlePageChange={handlePageChange}
              setPage={setPage}
              loading={loading}
              page={page}
              setDocOpen={setDocOpen}
              setSelectedQuatation={setSelectedQuatation}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={2}>
            <OffersApprovedList
              count={count}
              rows={rows}
              handlePageChange={handlePageChange}
              setPage={setPage}
              loading={loading}
              page={page}
              setDocOpen={setDocOpen}
              setSelectedQuatation={setSelectedQuatation}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={3}>
            <OffersScheduledList
              count={count}
              rows={rows}
              handlePageChange={handlePageChange}
              setPage={setPage}
              loading={loading}
              page={page}
              setDocOpen={setDocOpen}
              setSelectedQuatation={setSelectedQuatation}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={4}>
            <OffersInprogressList
              count={count}
              rows={rows}
              handlePageChange={handlePageChange}
              setPage={setPage}
              loading={loading}
              page={page}
              setDocOpen={setDocOpen}
              setSelectedQuatation={setSelectedQuatation}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={5}>
            <OffersCompletedList
              count={count}
              rows={rows}
              handlePageChange={handlePageChange}
              setPage={setPage}
              loading={loading}
              page={page}
              setDocOpen={setDocOpen}
              handleInvoice={handleInvoice}
              setSelectedQuatation={setSelectedQuatation}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={6}>
            <OffersRejectedList
              count={count}
              rows={rows}
              handlePageChange={handlePageChange}
              setPage={setPage}
              loading={loading}
              page={page}
              setDocOpen={setDocOpen}
              setSelectedQuatation={setSelectedQuatation}
            />
          </CustomTabPanel>
        </Box>
      </div>
      <TeamDocumentModal
        quatation={selectedQuatation || ""}
        open={docOpen}
        onClose={() => setDocOpen(!docOpen)}
        setOpen={setDocOpen}
      />
    </MainContainer>
  );
};

export default ManageOffers;
